var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

/**
 * The save conflict dialog.
 */
Curriculog.ProposalForm.FieldConflict = (function ($, _, Backbone, FieldConflict) {

    FieldConflict = Curriculog.CurriculogView.extend({

        //TODO: refactor this into a nunjucks template
        /**
         * init and open the dialog
         *
         * @param   {Object}   options
         * @param   {String}   options.yours - The value of the field as it is on the users page
         * @param   {HTML}     options.changed_data - The response of the conflict ajax
         * @param   {Deferred} options.defer - A deferred object to resolve when done.
         */
        initialize: function (options) {
            this.yours = options.yours;
            this.defer = options.defer || $.Deferred();

            this.parseData(options.changed_data);
            this.render();
        },

        parseData: function(data) {
            this.data = $(data);
            this.styles = this.data.filter('#conflict-color').contents();
            this.conflictId = this.data.find('#conflictEditId').val();
            this.ckeditor = this.data.find('textarea.ckeditor');
            this.dialog_el = this.data.filter('.field-conflict-dialog');
            this.diff = this.data.find('#field-conflict-diff-'+ this.conflictId);
            this.input = this.data.find('#field-conflict-value-'+ this.conflictId);
            this.dropdown = this.data.find('#field-conflict-dropdown-' + this.conflictId);
        },

        /**
         * Opens the conflict dialog
         *
         * @returns {promise} - See this.promise()
         */
        render: function() {
            var that = this,
                defer = this.defer;

            this.setElement(this.dialog_el);
            $('style').append(this.styles);

            // the diff comes pre hidden inside the dialog, idk why
            this.diff.show();

            // Add the current users changes to the input in the dialog
            this.input.val(this.yours);

            this.ckeditor.ckeditor(function(){
                that.ckeditor.ckeditorGet().on('instanceReady', function() {
                    this.document.on('drop', function(event) {
                        event.data.preventDefault(true);
                    });
                    this.focus();
                });
            });

            this.initDropdown();

            // Pop the dialog
            // this.dialog = new Curriculog.Dialog({
            //     el: that.$el,
            //     buttons: {
            //         'Save My Changes': function() {
            //             var corrected_value = that.input.val();
            //             defer.resolve(corrected_value);
            //             this.close();
            //         },

            //         Cancel: function() {
            //             this.close();
            //             defer.reject();
            //         }
            //     }
            // });
            this.dialog = new Curriculog.PromiseDialog({
                el: that.$el,
                buttons: {
                    'Save My Changes': '_resolve',
                    'Cancel': '_reject'
                }
            });

            this.dialog.done(function() {
                var corrected_value = that.input.val();
                defer.resolve(corrected_value);
            });

            this.dialog.fail(defer.reject);

            return defer.promise();
        },

        /**
         * Returns a promise object. This promise is resolved with the corrected
         *    changes or rejected on cancel.
         *
         * @returns {promise}
         */
        promise: function() {
            return this.defer.promise();
        },

        /**
         * Initializes the event handlers for the view switching dropdown
         */
        initDropdown: function() {
            // User Edits Dropdown - declare first because it interacts with editing
            this.dropdown.multiselect({
                minWidth: 600,
                classes: 'edits-filter-multiselect conflict-select',
                height: 80,
                header: false,
                noneSelectedText: 'Show current with markup',
                multiple: false,

                selectedText: function(numChecked, numTotal, checkedItems){
                    return $(checkedItems).attr('title');
                },

                click: _.bind(function(event, ui){
                    this.dropdown.find('option').removeAttr('selected');

                    if (ui.value === 'currentMarkup') {
                        this.$('.field-conflicts').hide();
                        this.$('#field-conflict-diff-' + this.conflictId).show();
                        this.dropdown.find('option[value="currentMarkup"]').attr('selected', 1);

                    } else if (ui.value === 'original') {
                        this.$('.field-conflicts').hide();
                        this.$('#field-conflict-original-' + this.conflictId).show();
                        this.dropdown.find('option[value="original"]').attr('selected', 1);

                    } else {
                        this.$('.field-conflicts').hide();
                        this.$('#field-conflict-current-'+ this.conflictId).show();
                        this.dropdown.find('option[value="current"]').attr('selected', 1);
                    }

                    this.dropdown.multiselect('refresh');
                }, this)
            });
        }

    });

    return FieldConflict;

})($, _, Backbone, Curriculog.ProposalForm.FieldConflict || {});